export const ENTITY_TAB_REQUESTS_SUB_TAB_QA_NAME = 'entityTabRequestsSubTab'

export const ENTITY_TAB_REQUESTS_SCALAR_SCOPE_FILTER_KEYS = [
  'for_building_group',
  'for_contractor',
  'staff_member',
]

export const ENTITY_TAB_REQUESTS_FILTER_BAR_ITEMS_PROPS = {
  SaveTemplateButton: null,
  ShareTemplateButton: null,
}

export const ENTITY_TAB_REQUESTS_DEFAULT_QA_NAME = {
  addNew: 'entityTabRequestsAddNew',
  export: 'entityTabRequestsExport',
  table: 'entityTabRequestsTable',
}
